import './style/index.js';

import _Rate from './Rate';

export type { RateProps } from './Rate';
export * from './type';

export const Rate = _Rate;
export default Rate;
